export const SEARCH_FORM_SUBMIT = 'STAFF.TEACHERS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'STAFF.TEACHERS.SORT_CHANGE';
export const PAGE_CHANGE = 'STAFF.TEACHERS.PAGE_CHANGE';
export const FETCH_LIST = 'STAFF.TEACHERS.FETCH_LIST';
